import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@b4m/b4m-frontend-core';
import { AdvertisingComponent } from './advertising.component';
import { AdvertisingListComponent } from './advertising-list/advertising-list.component';
import { AdvertisingAddEditComponent } from './advertising-add-edit/advertising-add-edit.component';
import { ClientResolve } from '../client-guard.service';

const advertisingRoutes: Routes = [
  {
    path: 'advertising',
    component: AdvertisingComponent,
    canActivate: [AuthGuard],
    resolve: [ClientResolve],
    data: { roles: ['ADMIN', 'USER'] },
    children: [
      {
        path: 'add',
        component: AdvertisingAddEditComponent,
        canActivate: [AuthGuard],
        canDeactivate: [AuthGuard],
        resolve: [ClientResolve],
        data: { roles: ['ADMIN', 'USER'] }
      },
      {
        path: 'edit/:id',
        component: AdvertisingAddEditComponent,
        canActivate: [AuthGuard],
        canDeactivate: [AuthGuard],
        resolve: [ClientResolve],
        data: { roles: ['ADMIN', 'USER'] }
      },
      {
        path: 'list',
        component: AdvertisingListComponent,
        canActivate: [AuthGuard],
        resolve: [ClientResolve],
        data: { roles: ['ADMIN', 'USER'] }
      }
    ]
  }
];

export const advertisingRouting = RouterModule.forChild(advertisingRoutes);
